var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, LinearGradient, Stop, ClipPath } from "react-native-svg";
var SvgAppStoreBlue = function SvgAppStoreBlue(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#clip0_3681_9597)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M13.522 0c2 0 3 0 4.09.333a4.204 4.204 0 0 1 2.532 2.534c.356 1.089.356 2.11.356 4.11v6.045c0 2 0 3-.333 4.09a4.205 4.205 0 0 1-2.534 2.532c-1.11.356-2.11.356-4.11.356H7.477c-2 0-3 0-4.09-.333A4.275 4.275 0 0 1 .834 17.11C.5 16.044.5 15.044.5 13.022V6.978c0-2 0-3 .333-4.09C1.278 1.712 2.19.779 3.39.357 4.456 0 5.456 0 7.478 0h6.044Z",
    fill: "url(#paint0_linear_3681_9597)"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.546 13.2c0-.622-.312-1.178-.8-1.467a.321.321 0 0 0-.156-.044H8.612l3.822-6.511c.267-.445.178-1.022-.244-1.311a.973.973 0 0 0-1.4.31l-.267.445-.244-.422c-.267-.422-.8-.622-1.267-.422a.947.947 0 0 0-.444 1.355l.822 1.4-3 5.156h-2.2c-.511 0-.956.355-1 .867a.964.964 0 0 0 .956 1.066h8.288c.023 0 .067-.022.067-.044l.008-.05a1.87 1.87 0 0 0 .037-.328Zm4.31-1.511c.512 0 .956.378 1 .867.045.577-.4 1.066-.955 1.066h-1.178l.867 1.49c.244.421.155 1-.244 1.288a.96.96 0 0 1-.578.2.98.98 0 0 1-.845-.489l-2.089-3.622-1.644-2.845c-.022-.022-.022-.044-.022-.088 0-.056-.006-.112-.011-.167a1.665 1.665 0 0 1-.011-.167c0-.778.177-1.555.533-2.178.044-.066.155-.066.2 0l2.711 4.623h2.267v.022ZM5.013 14.067c.022-.045.067-.067.111-.09.178-.044.356-.088.534-.088.489 0 .933.178 1.289.489a.137.137 0 0 1 .022.155l-.911 1.556a.979.979 0 0 1-.845.489.96.96 0 0 1-.578-.2c-.4-.29-.488-.867-.244-1.29l.622-1.021Z",
    fill: "white"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_3681_9597",
    x1: 0.5,
    y1: 0.006,
    x2: 0.5,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#19E6FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#1E51EE"
  })), /*#__PURE__*/React.createElement(ClipPath, {
    id: "clip0_3681_9597"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    transform: "translate(.5)",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgAppStoreBlue;